<template>
  <div class="clickStatistics-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-input placeholder="请输入通知码" size="small" v-model="form.noticeCode" class="param-input" @keyup.enter.native="getEmailList()"></el-input>
      <el-input placeholder="请输入标题" size="small" v-model="form.title" class="param-input" @keyup.enter.native="getEmailList()"></el-input>
      <el-select v-model="form.receiver" size="small" placeholder="接受者" @change="getEmailList('status')">
        <el-option v-for="item in receiver" :value="item.value" :label="item.label" :key="item.value"></el-option>
      </el-select>
      <el-button type="primary" size="small" @click="getEmailList('status')">搜索</el-button>
      <el-button type="primary" size="small" @click="addEmail('add')">+新增邮件</el-button>
    </div>
    <!--表格数据-->
    <el-table :data="tableData" border v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
      <el-table-column prop="noticeCode" label="通知码" align="center" width="300" fixed></el-table-column>
      <el-table-column prop="title" label="标题" align="center" width="250" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="receiver" label="接受者" align="center" width="150">
        <template slot-scope="scope">
          {{scope.row.receiver | reStatus}}
        </template>
      </el-table-column>
      <el-table-column prop="sendAt" label="发送时间" align="center" width="180">
        <template slot-scope="scope">
          {{scope.row.sendAt | changeDate}}
        </template>
      </el-table-column>
      <el-table-column prop="content" label="内容" align="center" :show-overflow-tooltip="true" width="400"></el-table-column>
      <el-table-column prop="remark" label="备注" align="center" width="400" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          {{scope.row.remark || '未知'}}
        </template>
      </el-table-column>
      <el-table-column prop="uidList" label="用户列表" align="center" width="350">
        <template slot-scope="scope">
          <span v-if="!scope.row.uidList || scope.row.uidList.length === 0">未知</span>
          <span v-for="(item,i) in scope.row.uidList" :key="i" v-else> {{item + ","}}</span>
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center" fixed="right" width="100">
        <template slot-scope="scope">
          <el-button type="danger" size="mini" icon="el-icon-delete" @click="removeMessage(scope.row._id)"></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination :page-sizes="[5, 10, 15, 20]" :current-page="form.pageNumber" :page-size="form.pageSize" layout="total, sizes, prev, pager, next, jumper" background :total="total" v-if="total > 10" @size-change="changeSize" @current-change="changeCurrent"></el-pagination>
    <add-email ref="addEmail" @handlerEmail="getEmailList('status')"></add-email>
  </div>
</template>
<script>
import API from '@/api'
import AddEmail from './components/addEmail'
export default {
  data() {
    return {
      tableData: [],
      loading: false,
      total: 0,
      time: '',
      // 接受者
      receiver: [
        {
          label: "全部",
          value: '',
        },
        {
          label: "所有用户",
          value: 'ALL_USER',
        },
        {
          label: "部分用户",
          value: 'SOME_USER',
        },
      ],
      // 是否开启
      enable: [
        {
          label: "全部",
          value: ""
        },
        {
          label: "是",
          value: true
        },
        {
          label: "否",
          value: false
        }
      ],
      // 广告点击请求列表参数
      form: {
        pageNumber: 1,
        pageSize: 10,
        noticeCode: '',
        title: '',
        receiver: "",
        enable: ""
      }
    }
  },
  components: {
    AddEmail
  },
  created() {
    this.getEmailList()
  },
  methods: {
    // 请求广告列表数据
    getEmailList(type) {
      this.loading = true
      if (type === 'status') {
        this.form.pageNumber = 1
      }
      API.getEmailList(this.form).then(res => {
        if (res.code === 200 && res.data.list.length > 0) {
          this.tableData = res.data.list
          this.total = res.data.total
        } else {
          this.tableData = []
          this.total = 0
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 分页条数改变回掉
    changeSize(size) {
      this.form.pageSize = size
      this.getEmailList()
    },
    // 分页页码改变回掉
    changeCurrent(number) {
      this.form.pageNumber = number
      this.getEmailList()
    },
    // 删除通知
    removeMessage(id) {
      this.$confirm('您确定要删除当前消息通知吗？', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          API.removeEmail({ id: id }).then(res => {
            if (res.code === 200) {
              this.$message({
                message: '删除消息成功！',
                type: 'success'
              })
              this.getEmailList()
            } else {
              this.$message.error('删除消息失败！')
            }
          })
        })
    },
    // 新增、编辑通知
    addEmail(type, data) {
      this.$refs.addEmail.open(type, data)
    }
  }
}
</script>
<style scoped lang="scss">
</style>
